import { render, staticRenderFns } from "./StateTag.vue?vue&type=template&id=2ceb44f2&scoped=true&lang=pug&"
import script from "./StateTag.vue?vue&type=script&lang=ts&"
export * from "./StateTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb44f2",
  null
  
)

export default component.exports